"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMenuPopper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _DropdownIcon = require("../DropdownIcon/DropdownIcon");
var _PropertyCardMenuPopper = require("./PropertyCardMenuPopper.styles");
var _excluded = ["children"];
var MoreIconOutlineAndFillSVG = function MoreIconOutlineAndFillSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 24 24"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    className: "MoreIcon__fill",
    d: "M4.5 9C2.84315 9 1.5 10.3431 1.5 12C1.5 13.6569 2.84315 15 4.5 15C6.15685 15 7.5 13.6569 7.5 12C7.5 10.3431 6.15685 9 4.5 9ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM16.5 12C16.5 10.3431 17.8431 9 19.5 9C21.1569 9 22.5 10.3431 22.5 12C22.5 13.6569 21.1569 15 19.5 15C17.8431 15 16.5 13.6569 16.5 12Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "MoreIcon__outline",
    d: "M1.5 12C1.5 10.3431 2.84315 9 4.5 9C6.15685 9 7.5 10.3431 7.5 12C7.5 13.6569 6.15685 15 4.5 15C2.84315 15 1.5 13.6569 1.5 12ZM6 12C6 11.1716 5.32843 10.5 4.5 10.5C3.67157 10.5 3 11.1716 3 12C3 12.8284 3.67157 13.5 4.5 13.5C5.32843 13.5 6 12.8284 6 12ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12ZM19.5 9C17.8431 9 16.5 10.3431 16.5 12C16.5 13.6569 17.8431 15 19.5 15C21.1569 15 22.5 13.6569 22.5 12C22.5 10.3431 21.1569 9 19.5 9ZM19.5 10.5C20.3284 10.5 21 11.1716 21 12C21 12.8284 20.3284 13.5 19.5 13.5C18.6716 13.5 18 12.8284 18 12C18 11.1716 18.6716 10.5 19.5 10.5Z"
  }));
};

/**
 * A custom menu popper used by `PropertyCard` to show a menu of actions.
 *
 * @since 8.63.0
 */
var PropertyCardMenuPopper = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PropertyCardMenuPopper.StyledPropertyCardMenuPopper, (0, _extends2.default)({
    ref: forwardedRef
  }, props), /*#__PURE__*/_react.default.createElement(_DropdownIcon.DropdownIcon, {
    icon: /*#__PURE__*/_react.default.createElement(MoreIconOutlineAndFillSVG, null),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }));
});
exports.PropertyCardMenuPopper = PropertyCardMenuPopper;
PropertyCardMenuPopper.displayName = 'PropertyCard.MenuPopper';
PropertyCardMenuPopper.propTypes = {
  /**
   * Will close the dropdown when the trigger is no longer visible in the viewport.
   */
  shouldCloseOnViewportLeave: _propTypes.default.bool
};
PropertyCardMenuPopper.defaultProps = {
  shouldCloseOnViewportLeave: false
};